"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Academy", {
  enumerable: true,
  get: function () {
    return _Academy.default;
  }
});
Object.defineProperty(exports, "Add", {
  enumerable: true,
  get: function () {
    return _Add.default;
  }
});
Object.defineProperty(exports, "AddToBag", {
  enumerable: true,
  get: function () {
    return _AddToBag.default;
  }
});
Object.defineProperty(exports, "AddToBagFilled", {
  enumerable: true,
  get: function () {
    return _AddToBagFilled.default;
  }
});
Object.defineProperty(exports, "AirplaneFilled", {
  enumerable: true,
  get: function () {
    return _AirplaneFilled.default;
  }
});
Object.defineProperty(exports, "AppHero", {
  enumerable: true,
  get: function () {
    return _AppHero.default;
  }
});
Object.defineProperty(exports, "AppNovage", {
  enumerable: true,
  get: function () {
    return _AppNovage.default;
  }
});
Object.defineProperty(exports, "AppReports", {
  enumerable: true,
  get: function () {
    return _AppReports.default;
  }
});
Object.defineProperty(exports, "Appsuite", {
  enumerable: true,
  get: function () {
    return _Appsuite.default;
  }
});
Object.defineProperty(exports, "AppsuiteFilled", {
  enumerable: true,
  get: function () {
    return _AppsuiteFilled.default;
  }
});
Object.defineProperty(exports, "ArrowDown", {
  enumerable: true,
  get: function () {
    return _ArrowDown.default;
  }
});
Object.defineProperty(exports, "ArrowDownThin", {
  enumerable: true,
  get: function () {
    return _ArrowDownThin.default;
  }
});
Object.defineProperty(exports, "ArrowLeft", {
  enumerable: true,
  get: function () {
    return _ArrowLeft.default;
  }
});
Object.defineProperty(exports, "ArrowLeftThin", {
  enumerable: true,
  get: function () {
    return _ArrowLeftThin.default;
  }
});
Object.defineProperty(exports, "ArrowRight", {
  enumerable: true,
  get: function () {
    return _ArrowRight.default;
  }
});
Object.defineProperty(exports, "ArrowRightSubmit", {
  enumerable: true,
  get: function () {
    return _ArrowRightSubmit.default;
  }
});
Object.defineProperty(exports, "ArrowRightThin", {
  enumerable: true,
  get: function () {
    return _ArrowRightThin.default;
  }
});
Object.defineProperty(exports, "ArrowUp", {
  enumerable: true,
  get: function () {
    return _ArrowUp.default;
  }
});
Object.defineProperty(exports, "ArrowUpThin", {
  enumerable: true,
  get: function () {
    return _ArrowUpThin.default;
  }
});
Object.defineProperty(exports, "Bank", {
  enumerable: true,
  get: function () {
    return _Bank.default;
  }
});
Object.defineProperty(exports, "BankFilled", {
  enumerable: true,
  get: function () {
    return _BankFilled.default;
  }
});
Object.defineProperty(exports, "BlogEmbedFilled", {
  enumerable: true,
  get: function () {
    return _BlogEmbedFilled.default;
  }
});
Object.defineProperty(exports, "Box", {
  enumerable: true,
  get: function () {
    return _Box.default;
  }
});
Object.defineProperty(exports, "BoxFilled", {
  enumerable: true,
  get: function () {
    return _BoxFilled.default;
  }
});
Object.defineProperty(exports, "BubbleHeart", {
  enumerable: true,
  get: function () {
    return _BubbleHeart.default;
  }
});
Object.defineProperty(exports, "BubbleHeartFilled", {
  enumerable: true,
  get: function () {
    return _BubbleHeartFilled.default;
  }
});
Object.defineProperty(exports, "BubbleHelp", {
  enumerable: true,
  get: function () {
    return _BubbleHelp.default;
  }
});
Object.defineProperty(exports, "BubbleHelpFilled", {
  enumerable: true,
  get: function () {
    return _BubbleHelpFilled.default;
  }
});
Object.defineProperty(exports, "BurgerMenu", {
  enumerable: true,
  get: function () {
    return _BurgerMenu.default;
  }
});
Object.defineProperty(exports, "Calendar", {
  enumerable: true,
  get: function () {
    return _Calendar.default;
  }
});
Object.defineProperty(exports, "CalendarFilled", {
  enumerable: true,
  get: function () {
    return _CalendarFilled.default;
  }
});
Object.defineProperty(exports, "CallHistory", {
  enumerable: true,
  get: function () {
    return _CallHistory.default;
  }
});
Object.defineProperty(exports, "Camera", {
  enumerable: true,
  get: function () {
    return _Camera.default;
  }
});
Object.defineProperty(exports, "CameraButton", {
  enumerable: true,
  get: function () {
    return _CameraButton.default;
  }
});
Object.defineProperty(exports, "CameraFilled", {
  enumerable: true,
  get: function () {
    return _CameraFilled.default;
  }
});
Object.defineProperty(exports, "Cancel", {
  enumerable: true,
  get: function () {
    return _Cancel.default;
  }
});
Object.defineProperty(exports, "Cashback", {
  enumerable: true,
  get: function () {
    return _Cashback.default;
  }
});
Object.defineProperty(exports, "Catalogue", {
  enumerable: true,
  get: function () {
    return _Catalogue.default;
  }
});
Object.defineProperty(exports, "CatalogueFilled", {
  enumerable: true,
  get: function () {
    return _CatalogueFilled.default;
  }
});
Object.defineProperty(exports, "Certificate", {
  enumerable: true,
  get: function () {
    return _Certificate.default;
  }
});
Object.defineProperty(exports, "CertificateFilled", {
  enumerable: true,
  get: function () {
    return _CertificateFilled.default;
  }
});
Object.defineProperty(exports, "Chart", {
  enumerable: true,
  get: function () {
    return _Chart.default;
  }
});
Object.defineProperty(exports, "ChartFilled", {
  enumerable: true,
  get: function () {
    return _ChartFilled.default;
  }
});
Object.defineProperty(exports, "Check", {
  enumerable: true,
  get: function () {
    return _Check.default;
  }
});
Object.defineProperty(exports, "CheckCircle", {
  enumerable: true,
  get: function () {
    return _CheckCircle.default;
  }
});
Object.defineProperty(exports, "CheckCircleFilled", {
  enumerable: true,
  get: function () {
    return _CheckCircleFilled.default;
  }
});
Object.defineProperty(exports, "CheckHeavy", {
  enumerable: true,
  get: function () {
    return _CheckHeavy.default;
  }
});
Object.defineProperty(exports, "CheckboxChecked", {
  enumerable: true,
  get: function () {
    return _CheckboxChecked.default;
  }
});
Object.defineProperty(exports, "CheckboxEmpty", {
  enumerable: true,
  get: function () {
    return _CheckboxEmpty.default;
  }
});
Object.defineProperty(exports, "CheckboxIndeterminate", {
  enumerable: true,
  get: function () {
    return _CheckboxIndeterminate.default;
  }
});
Object.defineProperty(exports, "Clear", {
  enumerable: true,
  get: function () {
    return _Clear.default;
  }
});
Object.defineProperty(exports, "ClearCircle", {
  enumerable: true,
  get: function () {
    return _ClearCircle.default;
  }
});
Object.defineProperty(exports, "ClearCircleFilled", {
  enumerable: true,
  get: function () {
    return _ClearCircleFilled.default;
  }
});
Object.defineProperty(exports, "ClearCircleTwoTone", {
  enumerable: true,
  get: function () {
    return _ClearCircleTwoTone.default;
  }
});
Object.defineProperty(exports, "Clock", {
  enumerable: true,
  get: function () {
    return _Clock.default;
  }
});
Object.defineProperty(exports, "ClockFilled", {
  enumerable: true,
  get: function () {
    return _ClockFilled.default;
  }
});
Object.defineProperty(exports, "Collect", {
  enumerable: true,
  get: function () {
    return _Collect.default;
  }
});
Object.defineProperty(exports, "Conference", {
  enumerable: true,
  get: function () {
    return _Conference.default;
  }
});
Object.defineProperty(exports, "ConsultantMypages", {
  enumerable: true,
  get: function () {
    return _ConsultantMypages.default;
  }
});
Object.defineProperty(exports, "ConsultantNetwork", {
  enumerable: true,
  get: function () {
    return _ConsultantNetwork.default;
  }
});
Object.defineProperty(exports, "ConsultantNetworkFilled", {
  enumerable: true,
  get: function () {
    return _ConsultantNetworkFilled.default;
  }
});
Object.defineProperty(exports, "ConsultantOrderFilled", {
  enumerable: true,
  get: function () {
    return _ConsultantOrderFilled.default;
  }
});
Object.defineProperty(exports, "ConsultantTrainingFilled", {
  enumerable: true,
  get: function () {
    return _ConsultantTrainingFilled.default;
  }
});
Object.defineProperty(exports, "Conversion", {
  enumerable: true,
  get: function () {
    return _Conversion.default;
  }
});
Object.defineProperty(exports, "ConversionFilled", {
  enumerable: true,
  get: function () {
    return _ConversionFilled.default;
  }
});
Object.defineProperty(exports, "Copy", {
  enumerable: true,
  get: function () {
    return _Copy.default;
  }
});
Object.defineProperty(exports, "CopyFilled", {
  enumerable: true,
  get: function () {
    return _CopyFilled.default;
  }
});
Object.defineProperty(exports, "CopyLink", {
  enumerable: true,
  get: function () {
    return _CopyLink.default;
  }
});
Object.defineProperty(exports, "CreditCard", {
  enumerable: true,
  get: function () {
    return _CreditCard.default;
  }
});
Object.defineProperty(exports, "CreditCardFilled", {
  enumerable: true,
  get: function () {
    return _CreditCardFilled.default;
  }
});
Object.defineProperty(exports, "Crown", {
  enumerable: true,
  get: function () {
    return _Crown.default;
  }
});
Object.defineProperty(exports, "CrownFilled", {
  enumerable: true,
  get: function () {
    return _CrownFilled.default;
  }
});
Object.defineProperty(exports, "Dashboard", {
  enumerable: true,
  get: function () {
    return _Dashboard.default;
  }
});
Object.defineProperty(exports, "DashboardFilled", {
  enumerable: true,
  get: function () {
    return _DashboardFilled.default;
  }
});
Object.defineProperty(exports, "Days", {
  enumerable: true,
  get: function () {
    return _Days.default;
  }
});
Object.defineProperty(exports, "DaysFilled", {
  enumerable: true,
  get: function () {
    return _DaysFilled.default;
  }
});
Object.defineProperty(exports, "Delay", {
  enumerable: true,
  get: function () {
    return _Delay.default;
  }
});
Object.defineProperty(exports, "Discount", {
  enumerable: true,
  get: function () {
    return _Discount.default;
  }
});
Object.defineProperty(exports, "DiscountTag", {
  enumerable: true,
  get: function () {
    return _DiscountTag.default;
  }
});
Object.defineProperty(exports, "DiscountTagFilled", {
  enumerable: true,
  get: function () {
    return _DiscountTagFilled.default;
  }
});
Object.defineProperty(exports, "Document", {
  enumerable: true,
  get: function () {
    return _Document.default;
  }
});
Object.defineProperty(exports, "DocumentFilled", {
  enumerable: true,
  get: function () {
    return _DocumentFilled.default;
  }
});
Object.defineProperty(exports, "Dollar", {
  enumerable: true,
  get: function () {
    return _Dollar.default;
  }
});
Object.defineProperty(exports, "Download", {
  enumerable: true,
  get: function () {
    return _Download.default;
  }
});
Object.defineProperty(exports, "Editorial", {
  enumerable: true,
  get: function () {
    return _Editorial.default;
  }
});
Object.defineProperty(exports, "EditorialFilled", {
  enumerable: true,
  get: function () {
    return _EditorialFilled.default;
  }
});
Object.defineProperty(exports, "Education", {
  enumerable: true,
  get: function () {
    return _Education.default;
  }
});
Object.defineProperty(exports, "EducationFilled", {
  enumerable: true,
  get: function () {
    return _EducationFilled.default;
  }
});
Object.defineProperty(exports, "Email", {
  enumerable: true,
  get: function () {
    return _Email.default;
  }
});
Object.defineProperty(exports, "EmailFilled", {
  enumerable: true,
  get: function () {
    return _EmailFilled.default;
  }
});
Object.defineProperty(exports, "EmailResend", {
  enumerable: true,
  get: function () {
    return _EmailResend.default;
  }
});
Object.defineProperty(exports, "EmailResendFilled", {
  enumerable: true,
  get: function () {
    return _EmailResendFilled.default;
  }
});
Object.defineProperty(exports, "EmptyBasket", {
  enumerable: true,
  get: function () {
    return _EmptyBasket.default;
  }
});
Object.defineProperty(exports, "EmptyBasketFilled", {
  enumerable: true,
  get: function () {
    return _EmptyBasketFilled.default;
  }
});
Object.defineProperty(exports, "Enlarge", {
  enumerable: true,
  get: function () {
    return _Enlarge.default;
  }
});
Object.defineProperty(exports, "ErrorCircle", {
  enumerable: true,
  get: function () {
    return _ErrorCircle.default;
  }
});
Object.defineProperty(exports, "ErrorCircleFilled", {
  enumerable: true,
  get: function () {
    return _ErrorCircleFilled.default;
  }
});
Object.defineProperty(exports, "Excel", {
  enumerable: true,
  get: function () {
    return _Excel.default;
  }
});
Object.defineProperty(exports, "Favourite", {
  enumerable: true,
  get: function () {
    return _Favourite.default;
  }
});
Object.defineProperty(exports, "FavouriteFilled", {
  enumerable: true,
  get: function () {
    return _FavouriteFilled.default;
  }
});
Object.defineProperty(exports, "Filter", {
  enumerable: true,
  get: function () {
    return _Filter.default;
  }
});
Object.defineProperty(exports, "FilterFilled", {
  enumerable: true,
  get: function () {
    return _FilterFilled.default;
  }
});
Object.defineProperty(exports, "Gift", {
  enumerable: true,
  get: function () {
    return _Gift.default;
  }
});
Object.defineProperty(exports, "GiftFilled", {
  enumerable: true,
  get: function () {
    return _GiftFilled.default;
  }
});
Object.defineProperty(exports, "Globe", {
  enumerable: true,
  get: function () {
    return _Globe.default;
  }
});
Object.defineProperty(exports, "GlobeFilled", {
  enumerable: true,
  get: function () {
    return _GlobeFilled.default;
  }
});
Object.defineProperty(exports, "Health", {
  enumerable: true,
  get: function () {
    return _Health.default;
  }
});
Object.defineProperty(exports, "Heart", {
  enumerable: true,
  get: function () {
    return _Heart.default;
  }
});
Object.defineProperty(exports, "HeartFilled", {
  enumerable: true,
  get: function () {
    return _HeartFilled.default;
  }
});
Object.defineProperty(exports, "HelpCircle", {
  enumerable: true,
  get: function () {
    return _HelpCircle.default;
  }
});
Object.defineProperty(exports, "HelpCircleFilled", {
  enumerable: true,
  get: function () {
    return _HelpCircleFilled.default;
  }
});
Object.defineProperty(exports, "Home", {
  enumerable: true,
  get: function () {
    return _Home.default;
  }
});
Object.defineProperty(exports, "HomeFilled", {
  enumerable: true,
  get: function () {
    return _HomeFilled.default;
  }
});
Object.defineProperty(exports, "ImageBlank", {
  enumerable: true,
  get: function () {
    return _ImageBlank.default;
  }
});
Object.defineProperty(exports, "ImageBlankFilled", {
  enumerable: true,
  get: function () {
    return _ImageBlankFilled.default;
  }
});
Object.defineProperty(exports, "InfoCircle", {
  enumerable: true,
  get: function () {
    return _InfoCircle.default;
  }
});
Object.defineProperty(exports, "InfoCircleFilled", {
  enumerable: true,
  get: function () {
    return _InfoCircleFilled.default;
  }
});
Object.defineProperty(exports, "Lightbulb", {
  enumerable: true,
  get: function () {
    return _Lightbulb.default;
  }
});
Object.defineProperty(exports, "Lipstick", {
  enumerable: true,
  get: function () {
    return _Lipstick.default;
  }
});
Object.defineProperty(exports, "LipstickFilled", {
  enumerable: true,
  get: function () {
    return _LipstickFilled.default;
  }
});
Object.defineProperty(exports, "List", {
  enumerable: true,
  get: function () {
    return _List.default;
  }
});
Object.defineProperty(exports, "Lock", {
  enumerable: true,
  get: function () {
    return _Lock.default;
  }
});
Object.defineProperty(exports, "LockFilled", {
  enumerable: true,
  get: function () {
    return _LockFilled.default;
  }
});
Object.defineProperty(exports, "LockUnlockedFilled", {
  enumerable: true,
  get: function () {
    return _LockUnlockedFilled.default;
  }
});
Object.defineProperty(exports, "Logout", {
  enumerable: true,
  get: function () {
    return _Logout.default;
  }
});
Object.defineProperty(exports, "LongArrowDown", {
  enumerable: true,
  get: function () {
    return _LongArrowDown.default;
  }
});
Object.defineProperty(exports, "LongArrowUp", {
  enumerable: true,
  get: function () {
    return _LongArrowUp.default;
  }
});
Object.defineProperty(exports, "MapPin", {
  enumerable: true,
  get: function () {
    return _MapPin.default;
  }
});
Object.defineProperty(exports, "MapPinFilled", {
  enumerable: true,
  get: function () {
    return _MapPinFilled.default;
  }
});
Object.defineProperty(exports, "MapPinFull", {
  enumerable: true,
  get: function () {
    return _MapPinFull.default;
  }
});
Object.defineProperty(exports, "MapSelector", {
  enumerable: true,
  get: function () {
    return _MapSelector.default;
  }
});
Object.defineProperty(exports, "Megaphone", {
  enumerable: true,
  get: function () {
    return _Megaphone.default;
  }
});
Object.defineProperty(exports, "Message", {
  enumerable: true,
  get: function () {
    return _Message.default;
  }
});
Object.defineProperty(exports, "MiniBag", {
  enumerable: true,
  get: function () {
    return _MiniBag.default;
  }
});
Object.defineProperty(exports, "MiniBagFilled", {
  enumerable: true,
  get: function () {
    return _MiniBagFilled.default;
  }
});
Object.defineProperty(exports, "More", {
  enumerable: true,
  get: function () {
    return _More.default;
  }
});
Object.defineProperty(exports, "MoreFilled", {
  enumerable: true,
  get: function () {
    return _MoreFilled.default;
  }
});
Object.defineProperty(exports, "Mute", {
  enumerable: true,
  get: function () {
    return _Mute.default;
  }
});
Object.defineProperty(exports, "MuteFilled", {
  enumerable: true,
  get: function () {
    return _MuteFilled.default;
  }
});
Object.defineProperty(exports, "MyBenefits", {
  enumerable: true,
  get: function () {
    return _MyBenefits.default;
  }
});
Object.defineProperty(exports, "MyBenefitsFilled", {
  enumerable: true,
  get: function () {
    return _MyBenefitsFilled.default;
  }
});
Object.defineProperty(exports, "Network", {
  enumerable: true,
  get: function () {
    return _Network.default;
  }
});
Object.defineProperty(exports, "NetworkFilled", {
  enumerable: true,
  get: function () {
    return _NetworkFilled.default;
  }
});
Object.defineProperty(exports, "NewUser", {
  enumerable: true,
  get: function () {
    return _NewUser.default;
  }
});
Object.defineProperty(exports, "NewUserFilled", {
  enumerable: true,
  get: function () {
    return _NewUserFilled.default;
  }
});
Object.defineProperty(exports, "NextCircle", {
  enumerable: true,
  get: function () {
    return _NextCircle.default;
  }
});
Object.defineProperty(exports, "NextCircleFilled", {
  enumerable: true,
  get: function () {
    return _NextCircleFilled.default;
  }
});
Object.defineProperty(exports, "Notification", {
  enumerable: true,
  get: function () {
    return _Notification.default;
  }
});
Object.defineProperty(exports, "NotificationFilled", {
  enumerable: true,
  get: function () {
    return _NotificationFilled.default;
  }
});
Object.defineProperty(exports, "Oriflame", {
  enumerable: true,
  get: function () {
    return _Oriflame.default;
  }
});
Object.defineProperty(exports, "OriflameSpinner", {
  enumerable: true,
  get: function () {
    return _OriflameSpinner.default;
  }
});
Object.defineProperty(exports, "Pause", {
  enumerable: true,
  get: function () {
    return _Pause.default;
  }
});
Object.defineProperty(exports, "Pbs", {
  enumerable: true,
  get: function () {
    return _Pbs.default;
  }
});
Object.defineProperty(exports, "Pen", {
  enumerable: true,
  get: function () {
    return _Pen.default;
  }
});
Object.defineProperty(exports, "PenFilled", {
  enumerable: true,
  get: function () {
    return _PenFilled.default;
  }
});
Object.defineProperty(exports, "PerfectStart", {
  enumerable: true,
  get: function () {
    return _PerfectStart.default;
  }
});
Object.defineProperty(exports, "PerfectStartFilled", {
  enumerable: true,
  get: function () {
    return _PerfectStartFilled.default;
  }
});
Object.defineProperty(exports, "Pickup", {
  enumerable: true,
  get: function () {
    return _Pickup.default;
  }
});
Object.defineProperty(exports, "PickupFilled", {
  enumerable: true,
  get: function () {
    return _PickupFilled.default;
  }
});
Object.defineProperty(exports, "Pin", {
  enumerable: true,
  get: function () {
    return _Pin.default;
  }
});
Object.defineProperty(exports, "PinFilled", {
  enumerable: true,
  get: function () {
    return _PinFilled.default;
  }
});
Object.defineProperty(exports, "Play", {
  enumerable: true,
  get: function () {
    return _Play.default;
  }
});
Object.defineProperty(exports, "PlayCircle", {
  enumerable: true,
  get: function () {
    return _PlayCircle.default;
  }
});
Object.defineProperty(exports, "PlayCircleFilled", {
  enumerable: true,
  get: function () {
    return _PlayCircleFilled.default;
  }
});
Object.defineProperty(exports, "PlayFilled", {
  enumerable: true,
  get: function () {
    return _PlayFilled.default;
  }
});
Object.defineProperty(exports, "PreviousCircle", {
  enumerable: true,
  get: function () {
    return _PreviousCircle.default;
  }
});
Object.defineProperty(exports, "PreviousCircleFilled", {
  enumerable: true,
  get: function () {
    return _PreviousCircleFilled.default;
  }
});
Object.defineProperty(exports, "Printer", {
  enumerable: true,
  get: function () {
    return _Printer.default;
  }
});
Object.defineProperty(exports, "PrinterFilled", {
  enumerable: true,
  get: function () {
    return _PrinterFilled.default;
  }
});
Object.defineProperty(exports, "PriorityHigh", {
  enumerable: true,
  get: function () {
    return _PriorityHigh.default;
  }
});
Object.defineProperty(exports, "Products", {
  enumerable: true,
  get: function () {
    return _Products.default;
  }
});
Object.defineProperty(exports, "ProductsFilled", {
  enumerable: true,
  get: function () {
    return _ProductsFilled.default;
  }
});
Object.defineProperty(exports, "ProgramPlus", {
  enumerable: true,
  get: function () {
    return _ProgramPlus.default;
  }
});
Object.defineProperty(exports, "ProgramPlusFill", {
  enumerable: true,
  get: function () {
    return _ProgramPlusFill.default;
  }
});
Object.defineProperty(exports, "QrCode", {
  enumerable: true,
  get: function () {
    return _QrCode.default;
  }
});
Object.defineProperty(exports, "RadioButtonChecked", {
  enumerable: true,
  get: function () {
    return _RadioButtonChecked.default;
  }
});
Object.defineProperty(exports, "RadioButtonEmpty", {
  enumerable: true,
  get: function () {
    return _RadioButtonEmpty.default;
  }
});
Object.defineProperty(exports, "Reduce", {
  enumerable: true,
  get: function () {
    return _Reduce.default;
  }
});
Object.defineProperty(exports, "Refresh", {
  enumerable: true,
  get: function () {
    return _Refresh.default;
  }
});
Object.defineProperty(exports, "Register", {
  enumerable: true,
  get: function () {
    return _Register.default;
  }
});
Object.defineProperty(exports, "RegisterFilled", {
  enumerable: true,
  get: function () {
    return _RegisterFilled.default;
  }
});
Object.defineProperty(exports, "Remove", {
  enumerable: true,
  get: function () {
    return _Remove.default;
  }
});
Object.defineProperty(exports, "Replace", {
  enumerable: true,
  get: function () {
    return _Replace.default;
  }
});
Object.defineProperty(exports, "ReplaceFilled", {
  enumerable: true,
  get: function () {
    return _ReplaceFilled.default;
  }
});
Object.defineProperty(exports, "ReplaceRound", {
  enumerable: true,
  get: function () {
    return _ReplaceRound.default;
  }
});
Object.defineProperty(exports, "Report", {
  enumerable: true,
  get: function () {
    return _Report.default;
  }
});
Object.defineProperty(exports, "ReportFilled", {
  enumerable: true,
  get: function () {
    return _ReportFilled.default;
  }
});
Object.defineProperty(exports, "Restore", {
  enumerable: true,
  get: function () {
    return _Restore.default;
  }
});
Object.defineProperty(exports, "Returned", {
  enumerable: true,
  get: function () {
    return _Returned.default;
  }
});
Object.defineProperty(exports, "RewardsHearts", {
  enumerable: true,
  get: function () {
    return _RewardsHearts.default;
  }
});
Object.defineProperty(exports, "RewardsHeartsFilled", {
  enumerable: true,
  get: function () {
    return _RewardsHeartsFilled.default;
  }
});
Object.defineProperty(exports, "RotateLeft", {
  enumerable: true,
  get: function () {
    return _RotateLeft.default;
  }
});
Object.defineProperty(exports, "RotateRight", {
  enumerable: true,
  get: function () {
    return _RotateRight.default;
  }
});
Object.defineProperty(exports, "Sales", {
  enumerable: true,
  get: function () {
    return _Sales.default;
  }
});
Object.defineProperty(exports, "SalesFilled", {
  enumerable: true,
  get: function () {
    return _SalesFilled.default;
  }
});
Object.defineProperty(exports, "Search", {
  enumerable: true,
  get: function () {
    return _Search.default;
  }
});
Object.defineProperty(exports, "Send", {
  enumerable: true,
  get: function () {
    return _Send.default;
  }
});
Object.defineProperty(exports, "SendFilled", {
  enumerable: true,
  get: function () {
    return _SendFilled.default;
  }
});
Object.defineProperty(exports, "Settings", {
  enumerable: true,
  get: function () {
    return _Settings.default;
  }
});
Object.defineProperty(exports, "SettingsFilled", {
  enumerable: true,
  get: function () {
    return _SettingsFilled.default;
  }
});
Object.defineProperty(exports, "Share", {
  enumerable: true,
  get: function () {
    return _Share.default;
  }
});
Object.defineProperty(exports, "ShareFilled", {
  enumerable: true,
  get: function () {
    return _ShareFilled.default;
  }
});
Object.defineProperty(exports, "Sharing", {
  enumerable: true,
  get: function () {
    return _Sharing.default;
  }
});
Object.defineProperty(exports, "ShoppingBasketFilled", {
  enumerable: true,
  get: function () {
    return _ShoppingBasketFilled.default;
  }
});
Object.defineProperty(exports, "Sort", {
  enumerable: true,
  get: function () {
    return _Sort.default;
  }
});
Object.defineProperty(exports, "SortAsc", {
  enumerable: true,
  get: function () {
    return _SortAsc.default;
  }
});
Object.defineProperty(exports, "SortDesc", {
  enumerable: true,
  get: function () {
    return _SortDesc.default;
  }
});
Object.defineProperty(exports, "Subscription", {
  enumerable: true,
  get: function () {
    return _Subscription.default;
  }
});
Object.defineProperty(exports, "SubscriptionFilled", {
  enumerable: true,
  get: function () {
    return _SubscriptionFilled.default;
  }
});
Object.defineProperty(exports, "Superdeal", {
  enumerable: true,
  get: function () {
    return _Superdeal.default;
  }
});
Object.defineProperty(exports, "SuperdealFilled", {
  enumerable: true,
  get: function () {
    return _SuperdealFilled.default;
  }
});
Object.defineProperty(exports, "Telephone", {
  enumerable: true,
  get: function () {
    return _Telephone.default;
  }
});
Object.defineProperty(exports, "TelephoneCircleFilled", {
  enumerable: true,
  get: function () {
    return _TelephoneCircleFilled.default;
  }
});
Object.defineProperty(exports, "TelephoneFilled", {
  enumerable: true,
  get: function () {
    return _TelephoneFilled.default;
  }
});
Object.defineProperty(exports, "Trashcan", {
  enumerable: true,
  get: function () {
    return _Trashcan.default;
  }
});
Object.defineProperty(exports, "TrashcanFilled", {
  enumerable: true,
  get: function () {
    return _TrashcanFilled.default;
  }
});
Object.defineProperty(exports, "Truck", {
  enumerable: true,
  get: function () {
    return _Truck.default;
  }
});
Object.defineProperty(exports, "TruckFilled", {
  enumerable: true,
  get: function () {
    return _TruckFilled.default;
  }
});
Object.defineProperty(exports, "Unlock", {
  enumerable: true,
  get: function () {
    return _Unlock.default;
  }
});
Object.defineProperty(exports, "UnlockFilled", {
  enumerable: true,
  get: function () {
    return _UnlockFilled.default;
  }
});
Object.defineProperty(exports, "Upgrade", {
  enumerable: true,
  get: function () {
    return _Upgrade.default;
  }
});
Object.defineProperty(exports, "UpgradeFilled", {
  enumerable: true,
  get: function () {
    return _UpgradeFilled.default;
  }
});
Object.defineProperty(exports, "User", {
  enumerable: true,
  get: function () {
    return _User.default;
  }
});
Object.defineProperty(exports, "UserFilled", {
  enumerable: true,
  get: function () {
    return _UserFilled.default;
  }
});
Object.defineProperty(exports, "VirtualTryon", {
  enumerable: true,
  get: function () {
    return _VirtualTryon.default;
  }
});
Object.defineProperty(exports, "Visibility", {
  enumerable: true,
  get: function () {
    return _Visibility.default;
  }
});
Object.defineProperty(exports, "VisibilityOff", {
  enumerable: true,
  get: function () {
    return _VisibilityOff.default;
  }
});
Object.defineProperty(exports, "Volume", {
  enumerable: true,
  get: function () {
    return _Volume.default;
  }
});
Object.defineProperty(exports, "VolumeFilled", {
  enumerable: true,
  get: function () {
    return _VolumeFilled.default;
  }
});
Object.defineProperty(exports, "Wallet", {
  enumerable: true,
  get: function () {
    return _Wallet.default;
  }
});
Object.defineProperty(exports, "WalletFilled", {
  enumerable: true,
  get: function () {
    return _WalletFilled.default;
  }
});
Object.defineProperty(exports, "Warning", {
  enumerable: true,
  get: function () {
    return _Warning.default;
  }
});
Object.defineProperty(exports, "WarningFilled", {
  enumerable: true,
  get: function () {
    return _WarningFilled.default;
  }
});
Object.defineProperty(exports, "WelcomeKit", {
  enumerable: true,
  get: function () {
    return _WelcomeKit.default;
  }
});
Object.defineProperty(exports, "WhatsNew", {
  enumerable: true,
  get: function () {
    return _WhatsNew.default;
  }
});
Object.defineProperty(exports, "ZoomIn", {
  enumerable: true,
  get: function () {
    return _ZoomIn.default;
  }
});
Object.defineProperty(exports, "ZoomOut", {
  enumerable: true,
  get: function () {
    return _ZoomOut.default;
  }
});
var _Academy = _interopRequireDefault(require("./Academy"));
var _AddToBagFilled = _interopRequireDefault(require("./AddToBagFilled"));
var _AddToBag = _interopRequireDefault(require("./AddToBag"));
var _Add = _interopRequireDefault(require("./Add"));
var _AirplaneFilled = _interopRequireDefault(require("./AirplaneFilled"));
var _AppHero = _interopRequireDefault(require("./AppHero"));
var _AppNovage = _interopRequireDefault(require("./AppNovage"));
var _AppReports = _interopRequireDefault(require("./AppReports"));
var _AppsuiteFilled = _interopRequireDefault(require("./AppsuiteFilled"));
var _Appsuite = _interopRequireDefault(require("./Appsuite"));
var _ArrowDownThin = _interopRequireDefault(require("./ArrowDownThin"));
var _ArrowDown = _interopRequireDefault(require("./ArrowDown"));
var _ArrowLeftThin = _interopRequireDefault(require("./ArrowLeftThin"));
var _ArrowLeft = _interopRequireDefault(require("./ArrowLeft"));
var _ArrowRightSubmit = _interopRequireDefault(require("./ArrowRightSubmit"));
var _ArrowRightThin = _interopRequireDefault(require("./ArrowRightThin"));
var _ArrowRight = _interopRequireDefault(require("./ArrowRight"));
var _ArrowUpThin = _interopRequireDefault(require("./ArrowUpThin"));
var _ArrowUp = _interopRequireDefault(require("./ArrowUp"));
var _BankFilled = _interopRequireDefault(require("./BankFilled"));
var _Bank = _interopRequireDefault(require("./Bank"));
var _BlogEmbedFilled = _interopRequireDefault(require("./BlogEmbedFilled"));
var _BoxFilled = _interopRequireDefault(require("./BoxFilled"));
var _Box = _interopRequireDefault(require("./Box"));
var _BubbleHeartFilled = _interopRequireDefault(require("./BubbleHeartFilled"));
var _BubbleHeart = _interopRequireDefault(require("./BubbleHeart"));
var _BubbleHelpFilled = _interopRequireDefault(require("./BubbleHelpFilled"));
var _BubbleHelp = _interopRequireDefault(require("./BubbleHelp"));
var _BurgerMenu = _interopRequireDefault(require("./BurgerMenu"));
var _CalendarFilled = _interopRequireDefault(require("./CalendarFilled"));
var _Calendar = _interopRequireDefault(require("./Calendar"));
var _CallHistory = _interopRequireDefault(require("./CallHistory"));
var _CameraButton = _interopRequireDefault(require("./CameraButton"));
var _CameraFilled = _interopRequireDefault(require("./CameraFilled"));
var _Camera = _interopRequireDefault(require("./Camera"));
var _Cancel = _interopRequireDefault(require("./Cancel"));
var _Cashback = _interopRequireDefault(require("./Cashback"));
var _CatalogueFilled = _interopRequireDefault(require("./CatalogueFilled"));
var _Catalogue = _interopRequireDefault(require("./Catalogue"));
var _CertificateFilled = _interopRequireDefault(require("./CertificateFilled"));
var _Certificate = _interopRequireDefault(require("./Certificate"));
var _ChartFilled = _interopRequireDefault(require("./ChartFilled"));
var _Chart = _interopRequireDefault(require("./Chart"));
var _CheckCircleFilled = _interopRequireDefault(require("./CheckCircleFilled"));
var _CheckCircle = _interopRequireDefault(require("./CheckCircle"));
var _CheckHeavy = _interopRequireDefault(require("./CheckHeavy"));
var _Check = _interopRequireDefault(require("./Check"));
var _CheckboxChecked = _interopRequireDefault(require("./CheckboxChecked"));
var _CheckboxEmpty = _interopRequireDefault(require("./CheckboxEmpty"));
var _CheckboxIndeterminate = _interopRequireDefault(require("./CheckboxIndeterminate"));
var _ClearCircleFilled = _interopRequireDefault(require("./ClearCircleFilled"));
var _ClearCircleTwoTone = _interopRequireDefault(require("./ClearCircleTwoTone"));
var _ClearCircle = _interopRequireDefault(require("./ClearCircle"));
var _Clear = _interopRequireDefault(require("./Clear"));
var _ClockFilled = _interopRequireDefault(require("./ClockFilled"));
var _Clock = _interopRequireDefault(require("./Clock"));
var _Collect = _interopRequireDefault(require("./Collect"));
var _Conference = _interopRequireDefault(require("./Conference"));
var _ConsultantMypages = _interopRequireDefault(require("./ConsultantMypages"));
var _ConsultantNetworkFilled = _interopRequireDefault(require("./ConsultantNetworkFilled"));
var _ConsultantNetwork = _interopRequireDefault(require("./ConsultantNetwork"));
var _ConsultantOrderFilled = _interopRequireDefault(require("./ConsultantOrderFilled"));
var _ConsultantTrainingFilled = _interopRequireDefault(require("./ConsultantTrainingFilled"));
var _ConversionFilled = _interopRequireDefault(require("./ConversionFilled"));
var _Conversion = _interopRequireDefault(require("./Conversion"));
var _CopyFilled = _interopRequireDefault(require("./CopyFilled"));
var _CopyLink = _interopRequireDefault(require("./CopyLink"));
var _Copy = _interopRequireDefault(require("./Copy"));
var _CreditCardFilled = _interopRequireDefault(require("./CreditCardFilled"));
var _CreditCard = _interopRequireDefault(require("./CreditCard"));
var _CrownFilled = _interopRequireDefault(require("./CrownFilled"));
var _Crown = _interopRequireDefault(require("./Crown"));
var _DashboardFilled = _interopRequireDefault(require("./DashboardFilled"));
var _Dashboard = _interopRequireDefault(require("./Dashboard"));
var _DaysFilled = _interopRequireDefault(require("./DaysFilled"));
var _Days = _interopRequireDefault(require("./Days"));
var _Delay = _interopRequireDefault(require("./Delay"));
var _DiscountTagFilled = _interopRequireDefault(require("./DiscountTagFilled"));
var _DiscountTag = _interopRequireDefault(require("./DiscountTag"));
var _Discount = _interopRequireDefault(require("./Discount"));
var _DocumentFilled = _interopRequireDefault(require("./DocumentFilled"));
var _Document = _interopRequireDefault(require("./Document"));
var _Dollar = _interopRequireDefault(require("./Dollar"));
var _Download = _interopRequireDefault(require("./Download"));
var _EditorialFilled = _interopRequireDefault(require("./EditorialFilled"));
var _Editorial = _interopRequireDefault(require("./Editorial"));
var _EducationFilled = _interopRequireDefault(require("./EducationFilled"));
var _Education = _interopRequireDefault(require("./Education"));
var _EmailFilled = _interopRequireDefault(require("./EmailFilled"));
var _EmailResendFilled = _interopRequireDefault(require("./EmailResendFilled"));
var _EmailResend = _interopRequireDefault(require("./EmailResend"));
var _Email = _interopRequireDefault(require("./Email"));
var _EmptyBasketFilled = _interopRequireDefault(require("./EmptyBasketFilled"));
var _EmptyBasket = _interopRequireDefault(require("./EmptyBasket"));
var _Enlarge = _interopRequireDefault(require("./Enlarge"));
var _ErrorCircleFilled = _interopRequireDefault(require("./ErrorCircleFilled"));
var _ErrorCircle = _interopRequireDefault(require("./ErrorCircle"));
var _Excel = _interopRequireDefault(require("./Excel"));
var _FavouriteFilled = _interopRequireDefault(require("./FavouriteFilled"));
var _Favourite = _interopRequireDefault(require("./Favourite"));
var _FilterFilled = _interopRequireDefault(require("./FilterFilled"));
var _Filter = _interopRequireDefault(require("./Filter"));
var _GiftFilled = _interopRequireDefault(require("./GiftFilled"));
var _Gift = _interopRequireDefault(require("./Gift"));
var _GlobeFilled = _interopRequireDefault(require("./GlobeFilled"));
var _Globe = _interopRequireDefault(require("./Globe"));
var _Health = _interopRequireDefault(require("./Health"));
var _HeartFilled = _interopRequireDefault(require("./HeartFilled"));
var _Heart = _interopRequireDefault(require("./Heart"));
var _HelpCircleFilled = _interopRequireDefault(require("./HelpCircleFilled"));
var _HelpCircle = _interopRequireDefault(require("./HelpCircle"));
var _HomeFilled = _interopRequireDefault(require("./HomeFilled"));
var _Home = _interopRequireDefault(require("./Home"));
var _ImageBlankFilled = _interopRequireDefault(require("./ImageBlankFilled"));
var _ImageBlank = _interopRequireDefault(require("./ImageBlank"));
var _InfoCircleFilled = _interopRequireDefault(require("./InfoCircleFilled"));
var _InfoCircle = _interopRequireDefault(require("./InfoCircle"));
var _Lightbulb = _interopRequireDefault(require("./Lightbulb"));
var _LipstickFilled = _interopRequireDefault(require("./LipstickFilled"));
var _Lipstick = _interopRequireDefault(require("./Lipstick"));
var _List = _interopRequireDefault(require("./List"));
var _LockFilled = _interopRequireDefault(require("./LockFilled"));
var _LockUnlockedFilled = _interopRequireDefault(require("./LockUnlockedFilled"));
var _Lock = _interopRequireDefault(require("./Lock"));
var _Logout = _interopRequireDefault(require("./Logout"));
var _LongArrowDown = _interopRequireDefault(require("./LongArrowDown"));
var _LongArrowUp = _interopRequireDefault(require("./LongArrowUp"));
var _MapPinFilled = _interopRequireDefault(require("./MapPinFilled"));
var _MapPinFull = _interopRequireDefault(require("./MapPinFull"));
var _MapPin = _interopRequireDefault(require("./MapPin"));
var _MapSelector = _interopRequireDefault(require("./MapSelector"));
var _Megaphone = _interopRequireDefault(require("./Megaphone"));
var _Message = _interopRequireDefault(require("./Message"));
var _MiniBagFilled = _interopRequireDefault(require("./MiniBagFilled"));
var _MiniBag = _interopRequireDefault(require("./MiniBag"));
var _MoreFilled = _interopRequireDefault(require("./MoreFilled"));
var _More = _interopRequireDefault(require("./More"));
var _MuteFilled = _interopRequireDefault(require("./MuteFilled"));
var _Mute = _interopRequireDefault(require("./Mute"));
var _MyBenefitsFilled = _interopRequireDefault(require("./MyBenefitsFilled"));
var _MyBenefits = _interopRequireDefault(require("./MyBenefits"));
var _NetworkFilled = _interopRequireDefault(require("./NetworkFilled"));
var _Network = _interopRequireDefault(require("./Network"));
var _NewUserFilled = _interopRequireDefault(require("./NewUserFilled"));
var _NewUser = _interopRequireDefault(require("./NewUser"));
var _NextCircleFilled = _interopRequireDefault(require("./NextCircleFilled"));
var _NextCircle = _interopRequireDefault(require("./NextCircle"));
var _NotificationFilled = _interopRequireDefault(require("./NotificationFilled"));
var _Notification = _interopRequireDefault(require("./Notification"));
var _OriflameSpinner = _interopRequireDefault(require("./OriflameSpinner"));
var _Oriflame = _interopRequireDefault(require("./Oriflame"));
var _Pause = _interopRequireDefault(require("./Pause"));
var _Pbs = _interopRequireDefault(require("./Pbs"));
var _PenFilled = _interopRequireDefault(require("./PenFilled"));
var _Pen = _interopRequireDefault(require("./Pen"));
var _PerfectStartFilled = _interopRequireDefault(require("./PerfectStartFilled"));
var _PerfectStart = _interopRequireDefault(require("./PerfectStart"));
var _PickupFilled = _interopRequireDefault(require("./PickupFilled"));
var _Pickup = _interopRequireDefault(require("./Pickup"));
var _PinFilled = _interopRequireDefault(require("./PinFilled"));
var _Pin = _interopRequireDefault(require("./Pin"));
var _PlayCircleFilled = _interopRequireDefault(require("./PlayCircleFilled"));
var _PlayCircle = _interopRequireDefault(require("./PlayCircle"));
var _PlayFilled = _interopRequireDefault(require("./PlayFilled"));
var _Play = _interopRequireDefault(require("./Play"));
var _PreviousCircleFilled = _interopRequireDefault(require("./PreviousCircleFilled"));
var _PreviousCircle = _interopRequireDefault(require("./PreviousCircle"));
var _PrinterFilled = _interopRequireDefault(require("./PrinterFilled"));
var _Printer = _interopRequireDefault(require("./Printer"));
var _PriorityHigh = _interopRequireDefault(require("./PriorityHigh"));
var _ProductsFilled = _interopRequireDefault(require("./ProductsFilled"));
var _Products = _interopRequireDefault(require("./Products"));
var _ProgramPlusFill = _interopRequireDefault(require("./ProgramPlusFill"));
var _ProgramPlus = _interopRequireDefault(require("./ProgramPlus"));
var _QrCode = _interopRequireDefault(require("./QrCode"));
var _RadioButtonChecked = _interopRequireDefault(require("./RadioButtonChecked"));
var _RadioButtonEmpty = _interopRequireDefault(require("./RadioButtonEmpty"));
var _Reduce = _interopRequireDefault(require("./Reduce"));
var _Refresh = _interopRequireDefault(require("./Refresh"));
var _RegisterFilled = _interopRequireDefault(require("./RegisterFilled"));
var _Register = _interopRequireDefault(require("./Register"));
var _Remove = _interopRequireDefault(require("./Remove"));
var _ReplaceFilled = _interopRequireDefault(require("./ReplaceFilled"));
var _ReplaceRound = _interopRequireDefault(require("./ReplaceRound"));
var _Replace = _interopRequireDefault(require("./Replace"));
var _ReportFilled = _interopRequireDefault(require("./ReportFilled"));
var _Report = _interopRequireDefault(require("./Report"));
var _Restore = _interopRequireDefault(require("./Restore"));
var _Returned = _interopRequireDefault(require("./Returned"));
var _RewardsHeartsFilled = _interopRequireDefault(require("./RewardsHeartsFilled"));
var _RewardsHearts = _interopRequireDefault(require("./RewardsHearts"));
var _RotateLeft = _interopRequireDefault(require("./RotateLeft"));
var _RotateRight = _interopRequireDefault(require("./RotateRight"));
var _SalesFilled = _interopRequireDefault(require("./SalesFilled"));
var _Sales = _interopRequireDefault(require("./Sales"));
var _Search = _interopRequireDefault(require("./Search"));
var _SendFilled = _interopRequireDefault(require("./SendFilled"));
var _Send = _interopRequireDefault(require("./Send"));
var _SettingsFilled = _interopRequireDefault(require("./SettingsFilled"));
var _Settings = _interopRequireDefault(require("./Settings"));
var _ShareFilled = _interopRequireDefault(require("./ShareFilled"));
var _Share = _interopRequireDefault(require("./Share"));
var _Sharing = _interopRequireDefault(require("./Sharing"));
var _ShoppingBasketFilled = _interopRequireDefault(require("./ShoppingBasketFilled"));
var _SortAsc = _interopRequireDefault(require("./SortAsc"));
var _SortDesc = _interopRequireDefault(require("./SortDesc"));
var _Sort = _interopRequireDefault(require("./Sort"));
var _SubscriptionFilled = _interopRequireDefault(require("./SubscriptionFilled"));
var _Subscription = _interopRequireDefault(require("./Subscription"));
var _SuperdealFilled = _interopRequireDefault(require("./SuperdealFilled"));
var _Superdeal = _interopRequireDefault(require("./Superdeal"));
var _TelephoneCircleFilled = _interopRequireDefault(require("./TelephoneCircleFilled"));
var _TelephoneFilled = _interopRequireDefault(require("./TelephoneFilled"));
var _Telephone = _interopRequireDefault(require("./Telephone"));
var _TrashcanFilled = _interopRequireDefault(require("./TrashcanFilled"));
var _Trashcan = _interopRequireDefault(require("./Trashcan"));
var _TruckFilled = _interopRequireDefault(require("./TruckFilled"));
var _Truck = _interopRequireDefault(require("./Truck"));
var _UnlockFilled = _interopRequireDefault(require("./UnlockFilled"));
var _Unlock = _interopRequireDefault(require("./Unlock"));
var _UpgradeFilled = _interopRequireDefault(require("./UpgradeFilled"));
var _Upgrade = _interopRequireDefault(require("./Upgrade"));
var _UserFilled = _interopRequireDefault(require("./UserFilled"));
var _User = _interopRequireDefault(require("./User"));
var _VirtualTryon = _interopRequireDefault(require("./VirtualTryon"));
var _VisibilityOff = _interopRequireDefault(require("./VisibilityOff"));
var _Visibility = _interopRequireDefault(require("./Visibility"));
var _VolumeFilled = _interopRequireDefault(require("./VolumeFilled"));
var _Volume = _interopRequireDefault(require("./Volume"));
var _WalletFilled = _interopRequireDefault(require("./WalletFilled"));
var _Wallet = _interopRequireDefault(require("./Wallet"));
var _WarningFilled = _interopRequireDefault(require("./WarningFilled"));
var _Warning = _interopRequireDefault(require("./Warning"));
var _WelcomeKit = _interopRequireDefault(require("./WelcomeKit"));
var _WhatsNew = _interopRequireDefault(require("./WhatsNew"));
var _ZoomIn = _interopRequireDefault(require("./ZoomIn"));
var _ZoomOut = _interopRequireDefault(require("./ZoomOut"));
//# sourceMappingURL=index.js.map